import React from 'react';

import { Tab } from '@material-ui/core';
import { DeviceSearchFields, LocationSearchFields } from 'app/newnity/duck/types';
import { useTranslation } from 'react-i18next';
import { TabLabel } from '../tabLabel';
import { useStyles } from '../tabs.jss';
import { countNonEmptyDeviceInfoFields, countNonEmptyLocationInfoFields } from '../utils';

interface DeviceTabLabelsProps {
  location: LocationSearchFields;
  device: DeviceSearchFields;
  currentTabIndex: number;
  onTabChanged: (event: React.ChangeEvent<any>, newTabIndex: number) => void;
}

export const DeviceTabLabels = (props: DeviceTabLabelsProps) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <>
      <Tab
        value={0}
        onChange={props.onTabChanged}
        selected={props.currentTabIndex === 0}
        key="device.info"
        classes={{
          root: classes.tabRoot,
          selected: classes.tabFirstSelected,
          wrapper: classes.tabWrapper,
        }}
        label={
          <TabLabel
            label={t<string>('newnity.device')}
            numberOfNonEmptyFields={countNonEmptyDeviceInfoFields(props.device)}
          />
        }
      />
      <Tab
        value={1}
        onChange={props.onTabChanged}
        selected={props.currentTabIndex === 1}
        key="device.address"
        classes={{
          root: classes.tabRoot,
          selected: classes.tabLastSelected,
          wrapper: classes.tabWrapper,
        }}
        label={
          <TabLabel
            label={t<string>('newnity.search.locationAddress')}
            numberOfNonEmptyFields={countNonEmptyLocationInfoFields(props.location)}
          />
        }
      />
    </>
  );
};
